import { Contract } from "@/services/backend/rlt/contracts/types/contract";
import t from "@/lang/lang";
import { Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import {
  CommonDialogFooter,
  CommonDialogHeader,
} from "@/shared/components/dialog/dialog-common";
import { useRltContractRemoveTreatmentCycleMutation } from "@/services/backend/rlt/contracts/api/contract-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { toast } from "sonner";

export function RemoveTreatmentCycleDialog({
  contract,
  cycle,
}: {
  contract: Contract;
  cycle: number;
}) {
  const [open, setOpen] = useState(false);
  const [deleteCycle, { isLoading, error, isSuccess, reset }] =
    useRltContractRemoveTreatmentCycleMutation();

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
      toast.success(t("Turnus gelöscht"));
    }
  }, [isSuccess, reset]);

  const doDelete = () => {
    if (isLoading) return;

    deleteCycle({ id: contract.id, cycle });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive">
          <Trash2 className="size-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <CommonDialogHeader
          title={t("Turnus löschen")}
          description={t(
            "Möchten Sie den Turnus wirklich löschen? Alle zugehörigen Daten gehen dabei verloren.",
          )}
        />
        <RTKQueryErrorAlert error={error} onDismiss={reset} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
